<template>
	<div class="bg-color-white">
		<section
			class="client-returns-performance-section marketing-section gap-900-md container display-flex-md justify-content-space-between-md"
		>
			<div class="col-6-md">
				<h2 class="heading-xl my-100-smo"> See performance by fund </h2>
				<p class="body-xl mt-225-md">
					These publicly registered funds are our largest and most diversified, and are akin to mutual funds
					of alternative assets.
				</p>
			</div>
			<div class="col-6-md">
				<ul>
					<li v-for="(fund, index) in funds" :key="index" class="fund p-150-md py-150-smo bb mt-100-smo">
						<BaseLink
							:link="fund.link"
							classes="link gap-300 display-flex justify-content-space-between align-items-center"
						>
							<div>
								<span class="label-sm text-transform-uppercase text-color-content-secondary">{{
									fund.label
								}}</span>
								<h3 class="heading-2 mt-50">{{ fund.name }}</h3>
								<p class="body-sm m-0 text-color-content-secondary">{{ fund.description }}</p>
							</div>
							<span class="text-color-content-tertiary">
								<BaseSvgIcon
									height="48"
									width="48"
									role="presentation"
									class="arrow ml-50"
									name="chevron"
									dir="right"
								/>
							</span>
						</BaseLink>
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>
<script setup lang="ts">
import { flagshipFundOfferingId, growthTechReitId, incomeFundOfferingId } from '@constants/reit';
import { Link } from 'types/layout';

interface Fund {
	description: string;
	label: string;
	name: string;
	link: Link;
}
const funds: Array<Fund> = [
	{
		description:
			'Aims to give all investors the opportunity to invest in a portfolio of top-tier private technology companies before they IPO.',
		label: 'Venture',
		name: 'Innovation Fund',
		link: {
			router: 'view-offering-details',
			params: { offeringId: growthTechReitId },
			target: '_blank'
		}
	},
	{
		description:
			'An opportunistic strategy for income-focused investors that capitalizes on today’s lending environment.',
		label: 'Private credit',
		name: 'Income Fund',
		link: {
			router: 'view-offering-details',
			params: { offeringId: incomeFundOfferingId },
			target: '_blank'
		}
	},
	{
		description:
			'Designed to deliver long-term appreciation from a diversified portfolio of our most favored real estate investment strategies.',
		label: 'Real estate',
		name: 'Flagship Fund',
		link: {
			router: 'view-offering-details',
			params: { offeringId: flagshipFundOfferingId },
			target: '_blank'
		}
	}
];
</script>

<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;
@use '../../../styles/constants/colors' as *;

.client-returns-performance-section {
	@include respond-to(md) {
		&.gap-900-md {
			gap: 9rem;
		}
	}

	.bb {
		border-bottom-width: 2px;
	}

	.fund {
		:deep(.link) {
			color: token('content-primary');

			&:hover,
			&:focus,
			&:active {
				color: token('content-primary');

				.arrow {
					color: token('content-primary');
				}
			}
		}

		@include respond-to(md) {
			&:hover,
			&:focus,
			&:active {
				background-color: token('bg-secondary');
				cursor: pointer;
			}
		}
	}
}
</style>
